import { render, staticRenderFns } from "./mockup3.vue?vue&type=template&id=dd6e7748&scoped=true"
import script from "./mockup3.vue?vue&type=script&lang=js"
export * from "./mockup3.vue?vue&type=script&lang=js"
import style0 from "./mockup3.vue?vue&type=style&index=0&id=dd6e7748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6e7748",
  null
  
)

export default component.exports